//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import props from './core/props'
import VideoPlayer from './_sub/VideoPlayer.vue'
import VideoPoster from './_sub/VideoPoster.vue'
import VideoOverlay from './_sub/VideoOverlay.vue'

import resize from './core/resize'

export default {
  name: 'NjVideoBackground',
  components: {
    VideoPlayer,
    VideoPoster,
    VideoOverlay
  },
  mixins: [resize],
  props,
  computed: {
    player () {
      return this.$refs.player
    }
  },
  methods: {
    playVideo () {
      this.$emit('ready')
      if (!this.current.autoplay) { return }
      this.player.play()
    }
  }
}
